import { __assign, __read } from "tslib";
import React, { useState } from 'react';
import { Text } from '@keen.io/ui-core';
import { colors } from '@keen.io/colors';
import { StyledLabel, Wrapper, Circle } from './label.styles';
var Label = function (_a) {
    var text = _a.text, markColor = _a.markColor, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, typography = _a.typography, maxWidth = _a.maxWidth, _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b;
    var _c = __read(useState(isDisabled), 2), disabled = _c[0], setDisable = _c[1];
    var label = "" + text;
    return (React.createElement(StyledLabel, { onClick: function () {
            onClick(!disabled, label);
            setDisable(!disabled);
        }, onMouseEnter: function () { return !disabled && onMouseEnter(label); }, onMouseLeave: function () { return onMouseLeave(label); } },
        React.createElement(Wrapper, { role: "button", title: label, maxWidth: maxWidth, style: { opacity: disabled ? 0.6 : 1 } },
            React.createElement(Circle, { background: disabled ? colors.gray[400] : markColor }),
            React.createElement(Text, __assign({}, typography, { truncate: true }), label))));
};
export default Label;
